import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const ParkingPermit = ({ color }) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill={color} />
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="22">
        <path d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.5 7.5C3.5 6.94772 3.94772 6.5 4.5 6.5H17.5C18.0523 6.5 18.5 6.94772 18.5 7.5V14.5C18.5 15.0523 18.0523 15.5 17.5 15.5H4.5C3.94772 15.5 3.5 15.0523 3.5 14.5V7.5ZM11 8.5H17V9.5H11V8.5ZM7.85472 11.5465H6.84626V13.5H6V8.5H7.85472C8.81382 8.5 9.44852 9.1488 9.44852 10.0233C9.44852 10.9048 8.81382 11.5465 7.85472 11.5465ZM6.84626 10.799H7.72779C8.26375 10.799 8.58815 10.5028 8.58815 10.0303C8.58815 9.55078 8.26375 9.24753 7.72779 9.24753H6.84626V10.799ZM11 10.5H17V11.5H11V10.5ZM17 12.5H11V13.5H17V12.5Z" fill="white" />
      </g>
    </svg>
  )
}

ParkingPermit.defaultProps = {
  color: STYLE_CONSTANTS.colors.text.buttonGray
}

ParkingPermit.propTypes = {
  color: PropTypes.string
}

export default ParkingPermit